<div class="full-width drop-target" [class.drag-over]="dragOver" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <div *ngIf="canScann" class="card-inline">
        <h3>Escaneo</h3>
    </div>

    <div *ngIf="canScann" class="card-inline">
        <button class="card-inline" *ngIf="scanner && !readOnly && !hideScanner" (click)="openMedicalOrderScannDialog()" mat-mini-fab>
      <mat-icon>scanner</mat-icon>
    </button>

        <button class="card-inline" *ngIf="!scanner && !readOnly && !hideScanner" (click)="openScannSet()" mat-mini-fab>
      <mat-icon>scanner</mat-icon>
    </button>

        <div *ngIf="!readOnly" class="upload-dropzone" [class.drag-over]="dragOver">
            <button class="card-inline" type="button" (click)="fileInput.click()" mat-mini-fab>
            <mat-icon>cloud_upload</mat-icon>
          </button>
            <span class="upload-hint">Arrastra una imagen o PDF aquí o dentro del control</span>
            <input [style.display]="hideElement ? 'none' : 'inherit'" type="file" accept="image/*,.pdf" multiple #fileInput (change)="uploadFile($any($event.target).files)" />
        </div>

        <button *ngIf="!readOnly && canSelect && isMedicalOrderScannTypeSelected" class="card-inline" (click)="mecicalOrderSelected()" mat-mini-fab>
      <span class="material-symbols-outlined"> auto_awesome </span>
    </button>
    </div>

    <mat-divider></mat-divider>

    <div *ngIf="medicalOrderScannInfo">
        <br />
        <div>Protocolo: {{ medicalOrderScannInfo.Protocol }}</div>
        <div>
            Paciente: {{ medicalOrderScannInfo.PatientFullName }} ({{ medicalOrderScannInfo.PatientYear }})
        </div>
        <ng-container *ngIf="!hideProcedures">
            <div>Prácticas: <span #practicesText>{{ medicalOrderScannInfo.Practices.concat(" ") }}</span></div>
            <div>Adicionales: {{ medicalOrderScannInfo.Aditionals.concat(" ") }}</div>
            <div>Sets: {{ medicalOrderScannInfo.Sets.concat(" ") }}</div>
        </ng-container>
        <div>
            Equipo-Consultorio-Area extracción: {{ medicalOrderScannInfo.Equipment }}
        </div>
        <div *ngIf="deliveryDate">
            Fecha entrega informe/resultados: {{ deliveryDate }}
        </div>
        <br />
    </div>

    <mat-divider></mat-divider>
    <div class="center full-width">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <form [formGroup]="form">
            <mat-form-field *ngIf="!loading" class="full-width">
                <mat-select (selectionChange)="medicalOrderScannTypeChange()" formControlName="medicalOrderScannType" autofocus>
                    <mat-option *ngFor="let medicalOrderScannType of medicalOrderScannTypes" [value]="medicalOrderScannType">
                        {{ medicalOrderScannType.Name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>



            <div *ngIf="existsMedicalsOrderScann()" class="box1 center">
                <div class="display-button">
                    <button (click)="goBack()" mat-icon-button>
            <mat-icon>arrow_back</mat-icon>
          </button> {{ getDisplayIndex() }}
                    <button (click)="next()" mat-icon-button>
            <mat-icon>arrow_forward</mat-icon>
          </button>
                </div>

                <div>
                    <img *ngIf="!deleting && !loadingImage && getSafeUrl()" (click)="zoom()" [src]="getSafeUrl()" />

                    <iframe width="100%" height="800" *ngIf="!deleting && !loadingImage && getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>
                </div>

                <mat-spinner *ngIf="deleting || loadingImage" matSuffix></mat-spinner>
                <mat-card-actions>
                    <button *ngIf="!loadingImage && !deleting && !readOnly" type="button" (click)="remove()" mat-button>
            <mat-icon>delete_forever</mat-icon>
          </button>
                    <button *ngIf="!loadingImage && isImg() && !readOnly" type="button" (click)="rotate()" mat-button>
            <mat-icon>rotate_right</mat-icon>
          </button>
                    <button *ngIf="!loadingImage" type="button" (click)="print()" mat-button>
            <mat-icon>print</mat-icon>
          </button>
                </mat-card-actions>
            </div>
        </form>
    </div>
</div>
